function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 4v9h2V7.437l5.281 5.282 1.438-1.438L7.438 6H13V4zm15 0v2h5.563l-5.282 5.281 1.438 1.438L26 7.438V13h2V4zM4 19v9h9v-2H7.437l5.282-5.281-1.438-1.438L6 24.563V19zm22 0v5.563l-5.281-5.282-1.438 1.438L24.563 26H19v2h9v-9z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default SvgComponent;